module.exports = __webpack_public_path__ + "static/logo-w-4f8f949efe919c823f65592424b84fe9.svg";